import { URL_Dev } from "../Pages/Variables";

const ARABIC_PATHS = {
  team: "/\u0641\u0631\u064a\u0642\u0646\u0627",
  agency: "/\u0648\u0643\u0627\u0644\u062a\u0646\u0627",
  services: "/\u062a\u0637\u0648\u064a\u0631-\u0627\u0644\u0648\u064a\u0628",
  mobile: "/\u062a\u0637\u0648\u064a\u0631-\u0627\u0644\u0645\u062d\u0645\u0648\u0644",
  community: "/\u0625\u062f\u0627\u0631\u0629-\u0627\u0644\u0645\u062c\u062a\u0645\u0639",
  seo: "/\u0645\u062d\u0631\u0643-\u0627\u0644\u0628\u062d\u062b-\u0627\u0644\u0623\u0645\u062b\u0644",
  formulesSeo: "/\u0645\u062d\u0631\u0643-\u0627\u0644\u0628\u062d\u062b",
  consulting: "/\u062e\u062f\u0645\u0629-\u0627\u0633\u062a\u0634\u0627\u0631\u064a\u0629",
  serviceDelivery: "/\u062a\u0642\u062f\u064a\u0645-\u0627\u0644\u062e\u062f\u0645\u0629",
  portfolio: "/\u0645\u064e\u0644\u064e\u0641\u0651",
  filterPortfolio: "/\u062a\u0639\u0644\u064a\u0645\u0627\u062a-\u0627\u0644\u0627\u0633\u062a\u062e\u062f\u0627\u0645",
  contact: "/\u0627\u062a\u0635\u0644-\u0628\u0646\u0627",
  bowling: "/\u062d\u0644-\u0627\u0644\u0628\u0648\u0644\u064a\u0646\u062c-\u0644\u062f\u064a\u0646\u0627",
  legal: "/\u062a\u0639\u0644\u064a\u0645\u0627\u062a-\u0627\u0644\u0627\u0633\u062a\u062e\u062f\u0627\u0645",
};

const LANGUAGES = ["fr", "en", "ar"];

export const STATIC_ROUTE_GROUPS = [
  {
    key: "home",
    paths: {
      xDefault: "/",
      fr: "/fr",
      en: "/en",
      ar: "/ar",
    },
    slugs: {
      fr: "",
      en: "",
      ar: "",
    },
  },
  {
    key: "team",
    paths: {
      fr: "/fr/notre-equipe",
      en: "/en/our-team",
      ar: `/ar${ARABIC_PATHS.team}`,
    },
    slugs: {
      fr: "/notre-equipe",
      en: "/our-team",
      ar: ARABIC_PATHS.team,
    },
  },
  {
    key: "agency",
    paths: {
      fr: "/fr/notre-agence",
      en: "/en/our-agency",
      ar: `/ar${ARABIC_PATHS.agency}`,
    },
    slugs: {
      fr: "/notre-agence",
      en: "/our-agency",
      ar: ARABIC_PATHS.agency,
    },
  },
  {
    key: "services",
    paths: {
      fr: "/fr/nos-services",
      en: "/en/web-development",
      ar: `/ar${ARABIC_PATHS.services}`,
    },
    slugs: {
      fr: "/nos-services",
      en: "/web-development",
      ar: ARABIC_PATHS.services,
    },
  },
  {
    key: "mobile",
    paths: {
      fr: "/fr/developpement-mobile",
      en: "/en/mobile-development",
      ar: `/ar${ARABIC_PATHS.mobile}`,
    },
    slugs: {
      fr: "/developpement-mobile",
      en: "/mobile-development",
      ar: ARABIC_PATHS.mobile,
    },
  },
  {
    key: "community",
    paths: {
      fr: "/fr/community-management",
      en: "/en/community-management",
      ar: `/ar${ARABIC_PATHS.community}`,
    },
    slugs: {
      fr: "/community-management",
      en: "/community-management",
      ar: ARABIC_PATHS.community,
    },
  },
  {
    key: "seo",
    paths: {
      fr: "/fr/search-engine-optimization",
      en: "/en/search-engine-optimization",
      ar: `/ar${ARABIC_PATHS.seo}`,
    },
    slugs: {
      fr: "/search-engine-optimization",
      en: "/search-engine-optimization",
      ar: ARABIC_PATHS.seo,
    },
  },
  {
    key: "formules-seo",
    paths: {
      fr: "/fr/formules-seo",
      en: "/en/formules-seo",
      ar: `/ar${ARABIC_PATHS.formulesSeo}`,
    },
    slugs: {
      fr: "/formules-seo",
      en: "/formules-seo",
      ar: ARABIC_PATHS.formulesSeo,
    },
  },
  {
    key: "ui-ux",
    paths: {
      fr: "/fr/ui-ux",
      en: "/en/ui-ux",
      ar: "/ar/ui-ux",
    },
    slugs: {
      fr: "/ui-ux",
      en: "/ui-ux",
      ar: "/ui-ux",
    },
  },
  {
    key: "status",
    paths: {
      fr: "/fr/statut-des-services",
      en: "/en/statut-des-services",
      ar: "/ar/statut-des-services",
    },
    slugs: {
      fr: "/statut-des-services",
      en: "/statut-des-services",
      ar: "/statut-des-services",
    },
  },
  {
    key: "consulting",
    paths: {
      fr: "/fr/service-de-consultation",
      en: "/en/service-provision",
      ar: `/ar${ARABIC_PATHS.consulting}`,
    },
    slugs: {
      fr: "/service-de-consultation",
      en: "/service-provision",
      ar: ARABIC_PATHS.consulting,
    },
  },
  {
    key: "service-delivery",
    paths: {
      fr: "/fr/prestation-de-service",
      en: "/en/service-delivery",
      ar: `/ar${ARABIC_PATHS.serviceDelivery}`,
    },
    slugs: {
      fr: "/prestation-de-service",
      en: "/service-delivery",
      ar: ARABIC_PATHS.serviceDelivery,
    },
  },
  {
    key: "portfolio",
    paths: {
      fr: "/fr/nos-references",
      en: "/en/portfolio",
      ar: `/ar${ARABIC_PATHS.portfolio}`,
    },
    slugs: {
      fr: "/nos-references",
      en: "/portfolio",
      ar: ARABIC_PATHS.portfolio,
    },
  },
  {
    key: "filter-portfolio",
    paths: {
      fr: "/fr/filter-portfolio",
      en: "/en/filter-portfolio",
      ar: `/ar${ARABIC_PATHS.filterPortfolio}`,
    },
    slugs: {
      fr: "/filter-portfolio",
      en: "/filter-portfolio",
      ar: ARABIC_PATHS.filterPortfolio,
    },
  },
  {
    key: "contact",
    paths: {
      fr: "/fr/contact",
      en: "/en/contact-us",
      ar: `/ar${ARABIC_PATHS.contact}`,
    },
    slugs: {
      fr: "/contact",
      en: "/contact-us",
      ar: ARABIC_PATHS.contact,
    },
  },
  {
    key: "bowling",
    paths: {
      fr: "/fr/notre-solution-bowling",
      en: "/en/our-bowling-solution",
      ar: `/ar${ARABIC_PATHS.bowling}`,
    },
    slugs: {
      fr: "/notre-solution-bowling",
      en: "/our-bowling-solution",
      ar: ARABIC_PATHS.bowling,
    },
  },
  {
    key: "space-bowling",
    paths: {
      fr: "/fr/notre-solution-bowling/space-bowling",
      en: "/en/our-bowling-solution/space-bowling",
      ar: `/ar${ARABIC_PATHS.bowling}/space-bowling`,
    },
    slugs: {
      fr: "/notre-solution-bowling/space-bowling",
      en: "/our-bowling-solution/space-bowling",
      ar: `${ARABIC_PATHS.bowling}/space-bowling`,
    },
  },
  {
    key: "extra-laser-bowling",
    paths: {
      fr: "/fr/notre-solution-bowling/extra-laser-bowling",
      en: "/en/our-bowling-solution/extra-laser-bowling",
      ar: `/ar${ARABIC_PATHS.bowling}/extra-laser-bowling`,
    },
    slugs: {
      fr: "/notre-solution-bowling/extra-laser-bowling",
      en: "/our-bowling-solution/extra-laser-bowling",
      ar: `${ARABIC_PATHS.bowling}/extra-laser-bowling`,
    },
  },
  {
    key: "planet-bowling",
    paths: {
      fr: "/fr/notre-solution-bowling/planet-bowling",
      en: "/en/our-bowling-solution/planet-bowling",
      ar: `/ar${ARABIC_PATHS.bowling}/planet-bowling`,
    },
    slugs: {
      fr: "/notre-solution-bowling/planet-bowling",
      en: "/our-bowling-solution/planet-bowling",
      ar: `${ARABIC_PATHS.bowling}/planet-bowling`,
    },
  },
  {
    key: "limoges-bowling",
    paths: {
      fr: "/fr/notre-solution-bowling/bowling-de-limoges",
      en: "/en/our-bowling-solution/bowling-de-limoges",
      ar: `/ar${ARABIC_PATHS.bowling}/bowling-de-limoges`,
    },
    slugs: {
      fr: "/notre-solution-bowling/bowling-de-limoges",
      en: "/our-bowling-solution/bowling-de-limoges",
      ar: `${ARABIC_PATHS.bowling}/bowling-de-limoges`,
    },
  },
  {
    key: "cgv",
    paths: {
      fr: "/fr/Cgv",
      en: "/en/Cgv",
      ar: "/ar/Cgv",
    },
    slugs: {
      fr: "/Cgv",
      en: "/Cgv",
      ar: "/Cgv",
    },
  },
  {
    key: "legal",
    paths: {
      fr: "/fr/mentions-legales",
      en: "/en/terms-of-use",
      ar: `/ar${ARABIC_PATHS.legal}`,
    },
    slugs: {
      fr: "/mentions-legales",
      en: "/terms-of-use",
      ar: ARABIC_PATHS.legal,
    },
  },
  {
    key: "cgv-services",
    paths: {
      fr: "/fr/conditions-generales-de-vente-de-prestations-de-services",
      en: "/en/conditions-generales-de-vente-de-prestations-de-services",
      ar: "/ar/conditions-generales-de-vente-de-prestations-de-services",
    },
    slugs: {
      fr: "/conditions-generales-de-vente-de-prestations-de-services",
      en: "/conditions-generales-de-vente-de-prestations-de-services",
      ar: "/conditions-generales-de-vente-de-prestations-de-services",
    },
  },
  {
    key: "cgv-hosting",
    paths: {
      fr: "/fr/conditions-generales-de-vente-dhebergement-internet",
      en: "/en/conditions-generales-de-vente-dhebergement-internet",
      ar: "/ar/conditions-generales-de-vente-dhebergement-internet",
    },
    slugs: {
      fr: "/conditions-generales-de-vente-dhebergement-internet",
      en: "/conditions-generales-de-vente-dhebergement-internet",
      ar: "/conditions-generales-de-vente-dhebergement-internet",
    },
  },
  {
    key: "cgv-maintenance",
    paths: {
      fr: "/fr/conditions-generales-de-vente-maintenance-de-sites-internet",
      en: "/en/conditions-generales-de-vente-maintenance-de-sites-internet",
      ar: "/ar/conditions-generales-de-vente-maintenance-de-sites-internet",
    },
    slugs: {
      fr: "/conditions-generales-de-vente-maintenance-de-sites-internet",
      en: "/conditions-generales-de-vente-maintenance-de-sites-internet",
      ar: "/conditions-generales-de-vente-maintenance-de-sites-internet",
    },
  },
];

const BLOG_LIST_PATTERN = /^\/(?:(fr|en|ar)\/)?blog$/;
const BLOG_DETAIL_PATTERN = /^\/(?:(fr|en|ar)\/)?blog\/([^/]+)$/;

export function normalizePathname(pathname = "/") {
  if (!pathname) {
    return "/";
  }

  const rawPath = pathname.replace(/^https?:\/\/[^/]+/i, "").split(/[?#]/)[0] || "/";
  const normalized = rawPath.startsWith("/") ? rawPath : `/${rawPath}`;

  if (normalized.length > 1 && normalized.endsWith("/")) {
    return normalized.slice(0, -1);
  }

  return normalized;
}

function splitLocalizedPath(pathname) {
  const normalizedPath = normalizePathname(pathname);
  const segments = normalizedPath.split("/").filter(Boolean);
  const potentialLanguage = segments[0];

  if (LANGUAGES.includes(potentialLanguage)) {
    const rest = segments.slice(1).join("/");
    return {
      language: potentialLanguage,
      restPath: rest ? `/${rest}` : "",
    };
  }

  return {
    language: null,
    restPath: normalizedPath === "/" ? "" : normalizedPath,
  };
}

function buildAbsoluteUrl(pathname) {
  return `${URL_Dev}${encodeURI(normalizePathname(pathname))}`;
}

function matchStaticGroup(pathname) {
  const normalizedPath = normalizePathname(pathname);
  const { restPath } = splitLocalizedPath(normalizedPath);

  return (
    STATIC_ROUTE_GROUPS.find((group) => {
      if (group.key === "home") {
        return normalizedPath === "/" || normalizedPath === "/fr" || normalizedPath === "/en" || normalizedPath === "/ar";
      }

      return Object.values(group.slugs).includes(restPath || normalizedPath);
    }) || null
  );
}

function inferLanguageForGroup(pathname, group) {
  const normalizedPath = normalizePathname(pathname);
  const { language, restPath } = splitLocalizedPath(normalizedPath);

  if (group.key === "home") {
    return language;
  }

  if (language) {
    return language;
  }

  const matchingLanguage = Object.entries(group.slugs).find(([, slug]) => slug === (restPath || normalizedPath));
  return matchingLanguage ? matchingLanguage[0] : "fr";
}

function resolveBlogCanonicalPath(pathname) {
  const normalizedPath = normalizePathname(pathname);
  const detailMatch = normalizedPath.match(BLOG_DETAIL_PATTERN);

  if (detailMatch) {
    return `/fr/blog/${detailMatch[2]}`;
  }

  if (BLOG_LIST_PATTERN.test(normalizedPath)) {
    return "/fr/blog";
  }

  return null;
}

export function getCanonicalPath(pathname) {
  const blogCanonicalPath = resolveBlogCanonicalPath(pathname);
  if (blogCanonicalPath) {
    return blogCanonicalPath;
  }

  const normalizedPath = normalizePathname(pathname);
  const staticGroup = matchStaticGroup(normalizedPath);

  if (!staticGroup) {
    return normalizedPath;
  }

  if (staticGroup.key === "home" && normalizedPath === "/") {
    return "/";
  }

  const language = inferLanguageForGroup(normalizedPath, staticGroup);
  return staticGroup.paths[language] || staticGroup.paths.fr || normalizedPath;
}

export function getCanonicalUrl(pathname) {
  return buildAbsoluteUrl(getCanonicalPath(pathname));
}

export function getAlternateLanguageLinks(pathname) {
  const normalizedPath = normalizePathname(pathname);

  if (resolveBlogCanonicalPath(normalizedPath)) {
    return [];
  }

  const staticGroup = matchStaticGroup(normalizedPath);
  if (!staticGroup) {
    return [];
  }

  const links = LANGUAGES.map((language) => ({
    hrefLang: language,
    href: buildAbsoluteUrl(staticGroup.paths[language]),
  }));

  if (staticGroup.paths.xDefault) {
    links.push({
      hrefLang: "x-default",
      href: buildAbsoluteUrl(staticGroup.paths.xDefault),
    });
  }

  return links;
}

export function getStaticSitemapUrls() {
  return Array.from(
    new Set(
      STATIC_ROUTE_GROUPS.flatMap((group) => {
        const urls = Object.entries(group.paths)
          .filter(([language]) => language !== "xDefault")
          .map(([, path]) => buildAbsoluteUrl(path));

        return group.paths.xDefault ? [buildAbsoluteUrl(group.paths.xDefault), ...urls] : urls;
      })
    )
  );
}

export const DYNAMIC_SITEMAP_PATTERNS = {
  blog: "/fr/blog/:slug",
  portfolio: {
    fr: "/fr/details-de-portfolio/:slug",
    en: "/en/details-of-portfolio/:slug",
    ar: `/ar/\u062a\u0641\u0627\u0635\u064a\u0644-\u0627\u0644\u0645\u0644\u0641/:slug`,
  },
};

